import { render, staticRenderFns } from "./FetchList.vue?vue&type=template&id=ed5475de&scoped=true"
import script from "./FetchList.vue?vue&type=script&lang=js"
export * from "./FetchList.vue?vue&type=script&lang=js"
import style0 from "./FetchList.vue?vue&type=style&index=0&id=ed5475de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5475de",
  null
  
)

export default component.exports